const QuestionBank = {
    "question_bank": "Question Bank",
    "institute": "Institute",
    "branch": "Select Office",
    "test_designer": "Test Designer",
    "topic": "Test Paper",
    "bank_name": "Bank Name",
    "description": "Description",
    "search": "Search",
    "error_institute": "Select Institute",
    "error_branch": "Select Branch Office",
    "error_test_designer": "Select Test Designer",
    "error_topic": "Select Test Paper",
    "error_bank_name": "Enter Bank Name",
    "error_description": "Enter Description",
    "table_name": "BANK NAME",
    "table_designer": "TEST DESIGNER",
    "table_description": "DESCRIPTION",
}

export default QuestionBank;
